// import React, { Component } from 'react';
// import PropTypes from 'prop-types';
// import { withStyles } from 'material-ui/styles'

// import Button from 'material-ui/Button'
// // import BrightnessHigh from '@material-ui/icons/BrightnessHigh'
// // import BrightnessLow from '@material-ui/icons/BrightnessLow'
// // import Brightness5 from '@material-ui/icons/Brightness5'
// // import Brightness1 from '@material-ui/icons/Brightness1'
// import Brightness3 from '@material-ui/icons/Brightness3'
// import WbSunny from '@material-ui/icons/WbSunny'

// const styles = theme => ({
//   button: {
//     position: 'absolute',
//     zIndex: 1101,
//     top: 70,
//     right: 0,
//     margin: theme.spacing.unit,
//   },
//   leftIcon: {
//     marginRight: theme.spacing.unit,
//   },
//   rightIcon: {
//     marginLeft: theme.spacing.unit,
//   },
// });

// class ThemeSwitch extends Component {
//   render() {
//     return (
//       <Button
//         className={this.props.classes.button}
//         variant="raised"
//         color="secondary"
//         onClick={() => {
//           this.props.onThemeChange()
//         }}        
//       >
//         {`Mode: `}
//         {this.props.currentTheme === 'light'
//           ? <WbSunny className={this.props.classes.rightIcon} />
//           : <Brightness3 className={this.props.classes.rightIcon} />
//         }
//       </Button>
//     );
//   }
// }

// ThemeSwitch.propTypes = {
//   classes: PropTypes.object.isRequired,
//   currentTheme: PropTypes.string.isRequired,
//   onThemeChange: PropTypes.func.isRequired,
// };

// export default withStyles(styles)(ThemeSwitch)

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles'
import {
  FormControlLabel,
  FormGroup
} from 'material-ui/Form'
import Switch from 'material-ui/Switch'

const styles = theme => ({
  switch: {
    position: 'fixed',
    zIndex: theme.zIndex.appBar + 1,
    top: 70,
    right: 0,
    margin: theme.spacing.unit,
  },
});

const ThemeSwitch = ({ classes, currentTheme, onThemeChange }) =>
  <FormGroup
    className={classes.switch}
  >
    <FormControlLabel
      control={
        <Switch
          checked={currentTheme === 'light' ? true : false}
          onChange={() => {
            onThemeChange()
          }}
          aria-label="ThemeSwitch"
        />
      }
    // label={ currentTheme === 'light' ? 'Light' : 'Dark' }
    />
  </FormGroup>

ThemeSwitch.propTypes = {
  classes: PropTypes.object.isRequired,
  currentTheme: PropTypes.string.isRequired,
  onThemeChange: PropTypes.func.isRequired,
};

export default withStyles(styles)(ThemeSwitch)


// WEBPACK FOOTER //
// ./src/components/ThemeSwitch/index.js